
import {
  CREATE_SALESMAN_REQUEST,
  CREATE_SALESMAN_SUCCESS,
  CREATE_SALESMAN_FAIL,
  FETCH_SALESMAN_LIST_REQUEST,
  FETCH_SALESMAN_LIST_SUCCESS,
  FETCH_SALESMAN_LIST_FAIL,
  CREATE_SALESMAN_CUSTOMER_REQUEST,
  CREATE_SALESMAN_CUSTOMER_SUCCESS,
  CREATE_SALESMAN_CUSTOMER_FAIL,
  FETCH_SALESMAN_CUSTOMER_LIST_REQUEST,
  FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
  FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
  VALIDATE_QR_REQUEST,
  VALIDATE_QR_SUCCESS,
  VALIDATE_QR_FAIL,
  REDEEM_QR_REQUEST,
  REDEEM_QR_SUCCESS,
  REDEEM_QR_FAIL,
  FETCH_REDEMTION_CUSTOMER_REQUEST,
  FETCH_REDEMTION_CUSTOMER_SUCCESS,
  FETCH_REDEMTION_CUSTOMER_FAIL,
  GIFT_REDEEM_QR_REQUEST,
  GIFT_REDEEM_QR_SUCCESS,
  GIFT_REDEEM_QR_FAIL,
  FETCH_SALESMAN_DASHBOARD_DATA_REQUEST,
  FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS,
  FETCH_SALESMAN_DASHBOARD_DATA_FAIL,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  salesmen: [],
  customers: [],
  qrValidation: null,
  qrRedemption: null,
  error: null,
  redemptionCustomers: [],
  totalQRCodesUsed: 0,
  giftRedemption: null,
  dashboardData: null,
  consolidatedReport: null,
  reportLoading: false,
  reportError: null,
};

export const salesmanReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SALESMAN_REQUEST:
    case FETCH_SALESMAN_LIST_REQUEST:
    case CREATE_SALESMAN_CUSTOMER_REQUEST:
    case FETCH_SALESMAN_CUSTOMER_LIST_REQUEST:
    case VALIDATE_QR_REQUEST:
    case REDEEM_QR_REQUEST:
    case FETCH_REDEMTION_CUSTOMER_REQUEST:
    case GIFT_REDEEM_QR_REQUEST:
    case FETCH_SALESMAN_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_SALESMAN_SUCCESS:
      return {
        ...state,
        loading: false,
        salesmen: action.payload,
        error: null,
      };

    case FETCH_SALESMAN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        salesmen: action.payload,
        error: null,
      };

    case FETCH_REDEMTION_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        redemptionCustomers: action.payload?.data || action.payload || [],
        totalQRCodesUsed:
          action.payload?.total_qr_codes_used ?? state.totalQRCodesUsed,
        error: null,
      };

    case CREATE_SALESMAN_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload,
        error: null,
      };

    case FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload,
        error: null,
      };

    case VALIDATE_QR_SUCCESS:
      return {
        ...state,
        loading: false,
        qrValidation: action.payload,
        error: null,
      };

    case REDEEM_QR_SUCCESS:
      return {
        ...state,
        loading: false,
        qrRedemption: action.payload,
        error: null,
      };
    case GIFT_REDEEM_QR_SUCCESS:
      return {
        ...state,
        loading: false,
        giftRedemption: action.payload,
        
        error: null,
      };
    case FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS: // Add this
      return {
        ...state,
        loading: false,
        dashboardData: action.payload,
        error: null,
      };

    case FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST:
      return {
        ...state,
        reportLoading: true,
        reportError: null,
      };

    case FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS:
      return {
        ...state,
        reportLoading: false,
        consolidatedReport: action.payload,
        reportError: null,
      };

    case FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL:
      return {
        ...state,
        reportLoading: false,
        reportError: action.payload,
      };

    case CREATE_SALESMAN_FAIL:
    case FETCH_SALESMAN_LIST_FAIL:
    case CREATE_SALESMAN_CUSTOMER_FAIL:
    case FETCH_SALESMAN_CUSTOMER_LIST_FAIL:
    case VALIDATE_QR_FAIL:
    case REDEEM_QR_FAIL:
    case FETCH_REDEMTION_CUSTOMER_FAIL:
    case GIFT_REDEEM_QR_FAIL:
    case FETCH_SALESMAN_DASHBOARD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default salesmanReducer;
